import { FC, useState } from "react";
import { Link } from "react-router-dom";
import { TeamMembers } from "./TeamMembers";
import { TeamExperience } from "./TeamExperience";
import { QualityAssurance } from "./QualityAssurance";
import "../Contract.scss";

interface ISeaportCollapsables {
  team_member: boolean;
  team_experience: boolean;
  quality_assurance: boolean;
}

export const SeaportNxG: FC = () => {
  const [isCollapsed, setIsCollapsed] = useState<ISeaportCollapsables>({
    team_member: true,
    team_experience: true,
    quality_assurance: true,
  });
  return (
    <div className="Contract schedule70">
      <div className="Contract__wrapper">
        <Link className="back-to-contracts" to="/contract-vehicles">
          Back to Contracts
        </Link>
        <h1>Seaport-NxG</h1>
        <div className="Contract__wrapper__section">
          <h2>General Contract Information</h2>
          <div className="Contract__wrapper__section__content">
            <span>Contract Number: N00178-19-D-8340</span>
            <span>
              Customers: NAVSEA, NIWC (SPAWAR), NSWC, NAVSUP, MSC, NAVFAC, ONR
              and USMC
            </span>
            <span>
              Contract POP: 2 January 2019 through 31 December 2026 (including
              award term options)
            </span>
            <span>
              Program Ceiling: $5 Billion (including award term options)
            </span>
            <span>Available Order Types: CPFF, CPIF, CPAF, FFP, FPIF</span>
            <span>
              Contracts Manager and Contact for IDIQ Contracts: Phil Eagan,
              757-431-2400 Ext 1643
            </span>
            <span className="contact">
              <p>Contract POC: Philip M. Eagan - Chief Financial Officer</p>
              <p>Phone: 757-431-2400</p>
              <p>Email: phil.eagan@prosoft.us.com</p>
            </span>
            <p>Seaport-NxG Awardee Information:</p>
            <p>
              The PROSOFT Seaport-NxG Team is pleased to have been awarded a
              Seaport-NxG Multiple Award Contract (N00178-19-D-8340). The
              PROSOFT Team consists of companies with strategic key technical
              specialties to respond to orders issued under this contract by the
              Naval Sea Systems Command, Space and Naval Warfare Systems
              Command, Naval Supply Systems Command, Military Sealift Command,
              Naval Facilities Command, Office of Naval Research, or the United
              States Marine Corps. Team PROSOFT will provide services that
              potentially span the entire spectrum of mission areas and
              technical capabilities supported by the Department of the Navy
              (DON) ordering activities with services in 2 Categories
              (Engineering and Program Management) and 23 functional area
              subcategories. Each company participating on the team brings their
              own unique qualifications, experience and impressive performance
              record as a contribution to the success of the PROSOFT Seaport-NxG
              Team and equally supporting the execution customer missions in all
              Zones: Zone 1 - Northeast, Zone 2 - National Capital Region, Zone
              3 - MidAtlantic, Zone 4 - Gulf Coast, Zone 5 - Midwest, Zone 6 -
              Southwest, and Zone 7 - Northwest.
            </p>
          </div>
        </div>
        <TeamMembers
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <TeamExperience
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
        <QualityAssurance
          isCollapsed={isCollapsed}
          setIsCollapsed={setIsCollapsed}
        />
      </div>
    </div>
  );
};
